import React, { useState, useContext, useEffect } from 'react';
import { Button, Col, Form, Input, Row, Select, Space, Spin, Switch } from 'antd';
import axiosInstance from '../../../../../../../axios_instance';
import { IsAdminContext, UserStrengthPassionsDataContext, NumberOfStrengthPassionsContext } from '../../../../../../../context';
import { useParams } from 'react-router-dom';
import styles from "./styles.module.scss";
import { errorHandling } from '../../../../../../../utils/helper';

interface EditStrengthPassionProps {
  strength_passion_id: number;
  name: string;
  description: string;
  type: string;
  setIsEditable: any;
  show_in_resume: boolean;
}

const EditStrengthPassion: React.FC<EditStrengthPassionProps> = ({
  strength_passion_id,
  name,
  description,
  type,
  setIsEditable,
  show_in_resume
}) => {
  const { userStrengthPassionsData, setUserStrengthPassionsData } = useContext(UserStrengthPassionsDataContext);
  const [StrengthPassionValue, setStrengthPassionValue] = useState<number>(strength_passion_id);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [message, setMessage] = useState<string>();
  const { numberOfStrengthPassions, setNumberOfStrengthPassions } = useContext(NumberOfStrengthPassionsContext);

  const [showInResume, setShowInResume] = useState(true);

  const handleChangeResume = (value: any) => {
    setShowInResume(value);
  };


  const handleSave = (values: any) => {
    setIsSubmitted(true)

    // Condition to check if any changes were made
    if (strength_passion_id) {
      values.show_in_resume = showInResume;
      values.strength_passion_id = strength_passion_id;
      let url = '';
      if (isAdmin === '1') {
        url = '/api/v1/admin/profile/strength_passions';
        values.profile_id = employeeId;
      } else {
        url = '/api/v1/profile/strength_passions';
      }
      axiosInstance
        .post(url, values)
        .then((response) => {
          const userStrengthPassions = response.data.strength_passions.filter(
            (StrengthPassion: any) =>
              StrengthPassion['status']['id'] === 1
          );
          // const orderedProjects = response.data.projects.map((ProjectId: number) =>
          //   userProjects.find((userProject: any) => userProject.project_id === ProjectId)
          // ).filter((item: any) => item !== undefined);
          setUserStrengthPassionsData(userStrengthPassions);
          setIsEditable(false);
          setNumberOfStrengthPassions(userStrengthPassions.length);
        })
        .catch((error) => {
          console.log(error);
          errorHandling(error, setErrorMessage);
        })
        .finally(() => {
          setIsSubmitted(false)
        });
    } else {
      setIsEditable(false);
    }
  };

  useEffect(() => {
    if ((userStrengthPassionsData && userStrengthPassionsData.find((data: any) => data.strength_passion_id === StrengthPassionValue)) && (strength_passion_id !== StrengthPassionValue)) {
      setMessage("The Project already exists.")
    }
    else {
      setMessage("");
    }
  }, [StrengthPassionValue])

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row gutter={24} className={styles.row}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", position: "absolute", bottom: "8px", right: "8px" }}><Switch defaultChecked={show_in_resume} onChange={handleChangeResume} /><span>Show in resume</span></div>

          <Col span={6}>
            <Form.Item initialValue={type} name="type" label="Type">
              <Select placeholder="Select Type" optionLabelProp="label" options={[{ value: 1, label: "Strength" }, { value: 2, label: "Passion" }]} />
            </Form.Item>
          </Col>
          <Col span={6}></Col>
          <Col span={12}>
            <Form.Item initialValue={description} name="description" label="Description">
              <Input.TextArea rows={3} placeholder="Enter Description" />
            </Form.Item>
          </Col>
          <Col span={12}>
            {message && <p style={{ color: "green" }}>{message}</p>}
            <Form.Item initialValue={name} name="name" className={styles.title} labelAlign='left' label="Name" rules={[{ required: true, message: 'Please enter Strength or Passion Name' }]}>
              <Input placeholder="Enter Strength or Passion Name" />
            </Form.Item>
          </Col>

        </Row>
        <Row>
          {isSubmitted ? <Spin /> : null}
          <Form.Item style={{ marginLeft: 'auto' }}>
            <Space>
              <Button className={styles['save-button']} type="primary" htmlType="submit">
                Save
              </Button>
              <Button className={styles['cancel-button']} onClick={() => setIsEditable(false)}>Cancel</Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
};

export default EditStrengthPassion;
